import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  DeleteNoticeRepository,
  DeleteNoticeResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum DeleteNoticeState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: DeleteNoticeState;
  message: string;
}

const initialState: InitialState = {
  status: DeleteNoticeState.initial,
  message: "",
};

export const deleteNotice = createAsyncThunk(
  "deleteNotice",
  async (noticeId: number, { rejectWithValue }) => {
    try {
      const response: DeleteNoticeResponse = await DeleteNoticeRepository(
        noticeId
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const deleteNoticeSlice = createSlice({
  name: "deleteNotice",
  initialState,
  reducers: {
    resetDeleteNotice: (state) => {
      state.status = DeleteNoticeState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteNotice.pending, (state) => {
        state.status = DeleteNoticeState.inProgress;
      })
      .addCase(deleteNotice.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = DeleteNoticeState.success;
          state.message = message;
        }
      })
      .addCase(deleteNotice.rejected, (state, action) => {
        state.status = DeleteNoticeState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectDeleteNotice = (state: RootState) => state.deleteNotice;
export const { resetDeleteNotice } = deleteNoticeSlice.actions;
export default deleteNoticeSlice.reducer;
